import { useEffect, useState } from "react";
import styles from "./PresidentsMessage.module.css";

export default function PresidentsMessage() {

    const [showFullMessage, setShowFullMessage] = useState(false);
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth <= 768);
        };

        handleResize(); 
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    
    return <section className={styles.presidentMessagePage}>
             <h2 className={styles.PageName}>President's Message</h2>
             <section className={styles.Content}>
                <section className={styles.photoAndName}>
                    <img src="/trustees/presidentMessage.webp" alt="president" />
                
                    <div className={styles.name}>
                        <h3>Dr. Sachin S. Jadhav (BHMS)</h3>
                            <p>
                                <strong>President</strong>, <br/>Saiseva Bahuuddeshiya Seva Pratishthan,<br/>
                                K. P. Jadhav High School & Junior College<br/>
                                {/* Chimbhale, Tal. Shrigonda, Dist. Ahilya Nagar */}
                            </p>
                    </div>
                
                </section>

                <section className={styles.message}>

                    <p>
                        While pursuing my medical career, I realized the need to instill diligence and foster skilled, capable citizens 
                        to build a strong nation. With this vision, I founded the Saiseva Bahuuddeshiya Seva Pratishthan on December 
                        27, 2007, in the rural village of Chimbhale, Tal. Shrigonda, Dist. Ahilya Nagar, Maharashtra.
                    </p>
                    <p>
                        My passion for social service grew from witnessing the challenges faced by rural students, particularly the lack
                        of access to English-medium education. To address this, Our foundation established <a href='/hangeshwarPublicSchool' className={styles.SchoolLink}>Hangeshwar Public School</a> in 2009, 
                        equipping it with essential facilities and seeing rural students embrace this opportunity enthusiastically.
                    </p>
                    <p className={isSmallScreen && !showFullMessage ? styles.collapsed : styles.expanded}>
                        However, after Grade 10, many students faced difficulties continuing their education due to distance and 
                        societal barriers, especially for girls. This led to the establishment of K. P. Jadhav High School & Junior 
                        College in 2016, enabling students to pursue Arts, Commerce, or Science streams closer to home.
                    </p>
                    {(!isSmallScreen || showFullMessage)  && <p>
                        Today, the institution offers advanced facilities like computer labs, science laboratories, and libraries, 
                        empowering students to achieve their aspirations. Watching students from rural areas excel and contribute to 
                        their community is the greatest source of joy.
                    </p>}
                    {(!isSmallScreen || showFullMessage)  && <p>Thank you!</p>}

                    {isSmallScreen && (
                        <button 
                            className={styles.readMoreButton} 
                            onClick={() => setShowFullMessage(!showFullMessage)}
                        >
                            {showFullMessage ? 'Read Less' : 'Read More'}
                            {showFullMessage ?  <img src='/icons/readLess.png' alt='read less icon'/> : <img src='/icons/readMore.png' alt='read more icon'/>}
                        </button>
                    )}
                </section>
             </section>
        
        
        
    </section>
}